import Vue from 'vue';
import Router from 'vue-router';
const NotFound = () => import('../view/NotFound/404')
const welcome = () => import('../view/welcome/welcome')
const remoteMonitor = () => import('../view/remoteMonitor/remoteMonitor')
const callRecord = () => import('../view/callCenter/callRecord')
const cccHome = () => import('../view/callCenter/cccHome')
const visitManage = () => import('../view/callCenter/visitManage')

const detailMap = () => import('../view/welcome/detailMap')
const temp = () => import('../view/work/TemporaryMonitoring')
const realtimeMonitor = () => import('../view/work/userMonitor/index')
const listDetail = () => import('../view/work/listDetail')
const SBdetail = () => import('../view/work/SBdetail')
const HA03Detail = () => import('../view/work/HA03Detail/index')
const DeviceData = () => import('../view/deviceList/DeviceData/DeviceData')
const bloodPressureData = () => import('../view/bloodPressureList/bloodPressureData/bloodPressureData')
const realtimeLocation = () => import('../view/deviceList/DeviceData/realtimeLocation/realtimeLocation')
const healthData = () => import('../view/deviceList/DeviceData/healthData/healthData')
const abnormalData = () => import('../view/deviceList/DeviceData/abnormalData/abnormalData')
// import login from '@/view/login/login';
const login = () => import('../view/login/login')
const layout = () => import('../view/wordLayout/layout')
const listOfJobs = () => import('../view/wordLayout/layoutListOfJobs')
const listSchedule = () => import('../view/wordLayout/layoutSchedule')
const listArea = () => import('../view/wordLayout/layoutArea')
const warningDeal = () => import('../view/warningDeal/warningDeal')
const SleepZone = () => import('../view/SleepZone/SleepZone')
const test = () => import('../view/test')
const HA01Manage = () => import('../view/HA01Manage/HA01Manage')
const HA02Manage = () => import('../view/HA02Manage/HA02Manage')
const HA03Manage = () => import('../view/HA03Manage/HA03Manage')
const HA04Manage = () => import('../view/HA04Manage/HA04Manage')
const HA06Manage = () => import('../view/HA06Manage/HA06Manage')
const HA07Manage = () => import('../view/HA07Manage/HA07Manage')
const HA08Manage = () => import('../view/HA08Manage/HA08Manage')
const homeDeviceManage = () => import('../view/homeDeviceManage/homeDeviceManage')
const bloodPressureList = () => import('../view/bloodPressureList/bloodPressureList')
const serviceDispatch = () => import('../view/serviceDispatch/serviceDispatch')
const serviceEmployee = () => import('../view/serviceEmployee/serviceEmployee')
const serviceOganization = () => import('../view/serviceOganization/serviceOganization')
const serviceType = () => import('../view/serviceType/serviceType')
const serviceList = () => import('../view/serviceList/serviceList')
const bigScreen = () => import('../view/bigScreen/bigScreen')
const BigData = () => import('../view/BigData/BigData')
const BigDataU1 = () => import('../view/BigData/BigDataU1')
const BigDataUE_C = () => import('../view/BigData/BigDataUE_C')

const dataAnalyze = () => import('../view/dataAnalyze/dataAnalyze')
const deviceList = () => import('../view/deviceList/deviceList')
const DeviceDetail = () => import('../view/deviceList/DeviceDetail/DeviceDetail')
const BasicDeviceInfo = () => import('../view/deviceList/DeviceDetail/BasicInfo/BasicInfo')
const realTimeLineU1 = () => import('../view/deviceList/DeviceDetail/realTimeLineU1/realTimeLineU1')
const realTimeLineUE_C = () => import('../view/deviceList/DeviceDetail/realTimeLineU1/realTimeLineUE_C')

const Association = () => import('../view/deviceList/DeviceDetail/Association/Association')

const FamilyPhone = () => import('../view/deviceList/DeviceDetail/FamilyPhone/FamilyPhone')
const RemindList = () => import('../view/deviceList/DeviceDetail/RemindList/RemindList')
const DeviceLine = () => import('../view/deviceList/DeviceDetail/DeviceLine/DeviceLine')
const DeviceCall = () => import('../view/deviceList/DeviceDetail/DeviceCall/DeviceCall')
const DeviceEdit = () => import('../view/deviceList/DeviceEdit/DeviceEdit')
const SleepDetail = () => import('../view/SleepZone/SleepDetail')
const NewSleepDetail = () => import('../view/HA00-Manage/NewSleepDetail')
const userManagement = () => import('../view/userManagement/HomeUserMG')
const warningSetCommon = () => import('../view/warningSetting/warningSetCommon')
const sleepZoneSet = () => import('../view/warningSetting/sheelZoneSettingComon')
const personalSetting = () => import('../view/personalSetting/personalset')
const sleepZonePSet = () => import('../view/personalSetting/sheelZoonePset')
const userInfo = () => import('../view/userInfo/userInfo')
const BasicInfo = () => import('../view/userInfo/BasicInfo/BasicInfo')
const RelationInfo = () => import('../view/userInfo/RelationInfo/RelationInfo')
const HealthInfo = () => import('../view/userInfo/HealthInfo/HealthInfo')
const DeviceInfo = () => import('../view/userInfo/DeviceInfo/DeviceInfo')
const SMDInfo = () => import('../view/userInfo/SMDInfo/SMDInfo')
const SleepData = () => import('../view/userInfo/SleepData/SleepData')
const HemopiezometerInfo = () => import('../view/userInfo/HemopiezometerInfo/HemopiezometerInfo')
const personCondition = () => import('../view/reports/personCondition/personCondition')
const trendCondition = () => import('../view/reports/trendCondition/trendCondition')
const distributionCondition = () => import('../view/reports/distributionCondition/distributionCondition')
const report = () => import('../view/reports/report')
const statistics = () => import('../view/reports/statistics')
const accounting = () => import('../view/reports/accounting')
const businessTrend = () => import('../view/reports/businessTrend')
const staffReport = () => import('../view/reports/staffReport')
const deviceReport = () => import('../view/deviceReport/deviceReport')
const businessReport = () => import('../view/businessReport/businessReport')
const departmentMG = () => import('../view/systemMangement/departmentMG/departmentMG')
const employee = () => import('../view/systemMangement/employeeMG/employee')
const characterMG = () => import('../view/systemMangement/characterMG/characterMG')
const communityMG = () => import('../view/systemMangement/communityMG/communityMG')
const baseSet = () => import('../view/wordLayout/baseType')
const baseMG = () => import('../view/systemMangement/baseMG/baseMG')
const bedMG = () => import('../view/systemMangement/bedMG/bedMG')
const homeMG = () => import('../view/systemMangement/homeMG/homeMG')
const areaManage = () => import('../view/systemMangement/areaManage/areaManage')
const houseManage = () => import('../view/systemMangement/HouseManage/HouseManage')
const orgManage = () => import('../view/systemMangement/orgManage/orgManage')
const associatedHardware = () => import('../view/systemMangement/associatedHardware/associatedHardware')
const userDetail = () => import('../view/userDetail/userDetail')
const baseInfo = () => import('../view/userDetail/baseInfo/baseInfo')
const dataMonitoring = () => import('../view/userDetail/dataMonitoring/dataMonitoring')
const checkInfo = () => import('../view/userDetail/checkInfo/checkInfo')
const relative = () => import('../view/userDetail/relative/relative')
const sleepData = () => import('../view/userDetail/sleepData/sleepData')
const editUserDetail = () => import('../view/editUserDetail/userDetail')
const editBaseInfo = () => import('../view/editUserDetail/baseInfo/baseInfo')
const editCheckInfo = () => import('../view/editUserDetail/checkInfo/checkInfo')
const editRelative = () => import('../view/editUserDetail/relative/relative')
const realTimeLine = () => import('../view/realTimeLine/realTimeLine')
const index = () => import('../view/index')
const monitorDetail = () => import('../view/work/userMonitor/monitorDetail')
const oldManDetail = () => import('../view/work/userMonitor/oldManDetail')
const hytLabel = () => import('../view/deviceList/hytLabel/hytLabel')
const calibrationAddress = () => import('../view/deviceList/calibrationAddress/calibrationAddress')
const broadcastManage = () => import('../view/radioManage/radioManage')
const operationLog = () => import('../view/systemMangement/operationLog/operationLog')

const webviewHA11 = () => import('../view/deviceList/webviewHA11/index')

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [{
      path: '/',
      redirect: '/index/remoteMonitor',
      component: remoteMonitor,
      meta: {
        activeMenu: "/index/remoteMonitor", // 主菜单 的 接口文档 高亮
        apiActiveMenu: "/index/remoteMonitor" // 接口文档的子菜单高亮
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/detailMap',
      name: 'detailMap',
      component: detailMap
    },
    {
      path: '/index',
      component: index,
      children: [{
          path: 'broadcastManage',
          name: 'broadcastManage',
          component: broadcastManage,
          meta: {
            activeMenu: "/index/broadcastManage", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/broadcastManage" // 接口文档的子菜单高亮
          }
        },
        
        {
          path: "cccHome",
          name: 'cccHome',
          component: cccHome,
          meta: {
            activeMenu: "/index/cccHome", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/cccHome" // 接口文档的子菜单高亮
          },
        },
        {
          path: "callRecord",
          name: 'callRecord',
          component: callRecord,
          meta: {
            activeMenu: "/index/callRecord", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/callRecord" // 接口文档的子菜单高亮
          },
        },
        {
          path: "visitManage",
          name: 'visitManage',
          component: visitManage,
          meta: {
            activeMenu: "/index/visitManage", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/visitManage" // 接口文档的子菜单高亮
          },
        },


         {
          path: 'calibrationAddress',
          name: 'calibrationAddress',
          component: calibrationAddress
        }, {
          path: 'hytLabel',
          name: 'hytLabel',
          component: hytLabel
        },
        {
          path: 'welcome',
          name: 'welcome',
          component: welcome
        }, {
          path: 'remoteMonitor',
          name: 'remoteMonitor',
          component: remoteMonitor,
          meta: {
            activeMenu: "/index/remoteMonitor", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/remoteMonitor" // 接口文档的子菜单高亮
          }
        },
        // {
        //   path: "temp",
        //   name: 'temp',
        //   component: temp
        // },
        {
          path: "realtimeMonitor",
          name: 'realtimeMonitor',
          component: realtimeMonitor,
          meta: {
            activeMenu: "/index/realtimeMonitor", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/realtimeMonitor" // 接口文档的子菜单高亮
          }
        },
        {
          path: "test",
          name: 'test',
          component: test,
        },
        {
          path: 'monitorDetail',
          name: 'monitorDetail',
          component: monitorDetail
        },
        {
          path: 'oldManDetail',
          name: 'oldManDetail',
          component: oldManDetail
        },
        // {
        //   path: "userMonitor",
        //   name: 'userMonitor',
        //   component: userMonitor
        // },
        {
          path: "serviceDispatch",
          name: 'serviceDispatch',
          component: serviceDispatch,
          meta: {
            activeMenu: "/index/serviceDispatch", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/serviceDispatch" // 接口文档的子菜单高亮
          }
        },
        {
          path: "serviceEmployee",
          name: 'serviceEmployee',
          component: serviceEmployee
        }, {
          path: "serviceOganization",
          name: 'serviceOganization',
          component: serviceOganization
        }, {
          path: "serviceType",
          name: 'serviceType',
          component: serviceType,
          meta: {
            activeMenu: "/index/serviceType", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/serviceType" // 接口文档的子菜单高亮
          }
        }, {
          path: "serviceList",
          name: 'serviceList',
          component: serviceList,
          meta: {
            activeMenu: "/index/serviceList", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/serviceList" // 接口文档的子菜单高亮
          }
        },
        {
          path: "listDetail",
          name: 'listDetail',
          component: listDetail
        },
        {
          path: "SBdetail",
          name: 'SBdetail',
          component: SBdetail
        },
        {
          path: "webviewHA11",
          name: 'webviewHA11',
          component: webviewHA11
        },
        {
          path: "HA03Detail",
          name: 'HA03Detail',
          component: HA03Detail
        },
        {
          path: "bloodPressureData",
          name: 'bloodPressureData',
          component: bloodPressureData
        },

        {
          path: "realTimeLine",
          name: 'realTimeLine',
          component: realTimeLine
        },
        {
          path: "login",
          name: 'login',
          component: login
        },
        {
          path: 'layout',
          component: layout,
          children: [{
              path: '',
              component: listOfJobs
            },
            {
              path: 'listOfJobs',
              component: listOfJobs
            },
            {
              path: 'listSchedule',
              component: listSchedule
            },
            {
              path: 'listArea',
              component: listArea
            },
            {
              path: 'baseSet',
              component: baseSet
            }
          ]
        },
        {
          path: "warningDeal",
          name: 'warningDeal',
          component: warningDeal,
          meta: {
            activeMenu: "/index/warningDeal", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/warningDeal" // 接口文档的子菜单高亮
          }
        },
        {
          path: "SleepZone",
          name: 'SleepZone',
          component: SleepZone,
          meta: {
            activeMenu: "/index/SleepZone", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/SleepZone" // 接口文档的子菜单高亮
          }
        },
        {
          path: "SleepDetail",
          name: "SleepDetail",
          component: SleepDetail
        },
        {
          path: "NewSleepDetail",
          name: "NewSleepDetail",
          component: NewSleepDetail
        },
        {
          path: "HA01Manage",
          name: 'HA01Manage',
          component: HA01Manage
        },
        {
          path: "HA02Manage",
          name: 'HA02Manage',
          component: HA02Manage
        },
        {
          path: "HA03Manage",
          name: 'HA03Manage',
          component: HA03Manage
        },
        {
          path: "HA04Manage",
          name: 'HA04Manage',
          component: HA04Manage
        },
        {
          path: "HA06Manage",
          name: 'HA06Manage',
          component: HA06Manage
        },
        {
          path: "HA07Manage",
          name: 'HA07Manage',
          component: HA07Manage
        },
        {
          path: "HA08Manage",
          name: 'HA08Manage',
          component: HA08Manage
        },
        {
          path: "homeDeviceManage",
          name: 'homeDeviceManage',
          component: homeDeviceManage,
          meta: {
            activeMenu: "/index/homeDeviceManage", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/homeDeviceManage" // 接口文档的子菜单高亮
          }
        },
        {
          path: "deviceList",
          name: 'deviceList',
          component: deviceList,
          meta: {
            activeMenu: "/index/deviceList", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/deviceList" // 接口文档的子菜单高亮
          }
        },
        {
          path: "DeviceDetail",
          name: 'DeviceDetail',
          component: DeviceDetail,
          children: [{
              path: 'BasicDeviceInfo',
              name: 'BasicDeviceInfo',
              component: BasicDeviceInfo
            },
            {
              path: 'realTimeLineU1',
              name: 'realTimeLineU1',
              component: realTimeLineU1
            },
            {
              path: 'realTimeLineUE_C',
              name: 'realTimeLineUE_C',
              component: realTimeLineUE_C
            },
             {
              path: 'FamilyPhone',
              name: 'FamilyPhone',
              component: FamilyPhone
            },
            {
              path: 'Association',
              name: 'Association',
              component: Association
            },
             {
              path: 'RemindList',
              name: 'RemindList',
              component: RemindList
            },
            {
              path: 'DeviceCall',
              name: 'DeviceCall',
              component: DeviceCall
            },
            {
              path: 'DeviceLine',
              name: 'DeviceLine',
              component: DeviceLine
            },
            {
              path: "DeviceEdit",
              name: 'DeviceEdit',
              component: DeviceEdit,
            },
            {
              path: "DeviceData",
              name: 'DeviceData',
              component: DeviceData,
              children: [{
                path: 'realtimeLocation',
                name: 'realtimeLocation',
                component: realtimeLocation
              }, {
                path: 'healthData',
                name: 'healthData',
                component: healthData
              }, {
                path: 'abnormalData',
                name: 'abnormalData',
                component: abnormalData
              }, ]
            },
          ]

        },
        {
          path: "bloodPressureList",
          name: 'bloodPressureList',
          component: bloodPressureList,
          meta: {
            activeMenu: "/index/bloodPressureList", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/bloodPressureList" // 接口文档的子菜单高亮
          }
        },
        {
          path: "userManagement",
          name: 'userManagement',
          component: userManagement,
          meta: {
            activeMenu: "/index/userManagement", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/userManagement" // 接口文档的子菜单高亮
          }
        },
        {
          path: "warningSetting",
          component: warningSetCommon,
          children: [{
            path: 'sleepZoneSet',
            component: sleepZoneSet
          }, ]
        },
        {
          path: "personalSetting",
          component: personalSetting,
          children: [{
            name: 'sleepZonePSet',
            path: 'sleepZonePSet',
            component: sleepZonePSet
          }, ]
        },
        {
          path: "deviceReport",
          name: "deviceReport",
          component: deviceReport,
        },
        {
          path: "dataAnalyze",
          name: "dataAnalyze",
          component: dataAnalyze,
          meta: {
            activeMenu: "/index/dataAnalyze", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/dataAnalyze" // 接口文档的子菜单高亮
          }
        },
        {
          path: "bigScreen",
          name: "bigScreen",
          component: bigScreen,
          meta: {
            keepAlive: true // 需要缓存
          },
          meta: {
            activeMenu: "/index/bigScreen", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/bigScreen" // 接口文档的子菜单高亮
          }
        },
        {
          path: "businessReport",
          name: "businessReport",
          component: businessReport,
        },
        //系统设置
        {
          path: "departmentMG",
          name: "departmentMG",
          component: departmentMG,
        },
        {
          path: "employee",
          name: "employee",
          component: employee,
          meta: {
            activeMenu: "/index/employee", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/employee" // 接口文档的子菜单高亮
          }
        },
        {
          path: "characterMG",
          name: "characterMG",
          component: characterMG,
          meta: {
            activeMenu: "/index/characterMG", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/characterMG" // 接口文档的子菜单高亮
          }
        },
        {
          path: "communityMG",
          name: "communityMG",
          component: communityMG,
        },
        {
          path: "bedMG",
          name: "bedMG",
          component: bedMG,
        },
        {
          path: "homeMG",
          name: "homeMG",
          component: homeMG,
        },
        {
          path: "areaManage",
          name: "areaManage",
          component: areaManage,
        },
        {
          path: "houseManage",
          name: "houseManage",
          component: houseManage,
        },
        {
          path: "orgManage",
          name: "orgManage",
          component: orgManage,
          meta: {
            activeMenu: "/index/orgManage", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/orgManage" // 接口文档的子菜单高亮
          }
        },
        {
          path: "operationLog",
          name: "operationLog",
          component: operationLog,
          meta: {
            activeMenu: "/index/operationLog", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/operationLog" // 接口文档的子菜单高亮
          }
        },
        {
          path: "associatedHardware",
          name: "associatedHardware",
          component: associatedHardware,
          meta: {
            activeMenu: "/index/associatedHardware", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/associatedHardware" // 接口文档的子菜单高亮
          }
        },
        {
          path: "baseMG/baseSet",
          component: baseMG,
          meta: {
            activeMenu: "/index/baseMG/baseSet", // 主菜单 的 接口文档 高亮
            apiActiveMenu: "/index/baseMG/baseSet" // 接口文档的子菜单高亮
          }
        },
        //统计报表
        {
          path: "reports",
          component: report,
          children: [{
              path: 'staffReport',
              name: 'staffReport',
              component: staffReport,
              meta: {
                activeMenu: "/index/reports/staffReport", // 主菜单 的 接口文档 高亮
                apiActiveMenu: "/index/reports/staffReport" // 接口文档的子菜单高亮
              }
            },
            {
              path: 'trendCondition',
              name: 'trendCondition',
              component: trendCondition
            },
            {
              path: 'distributionCondition',
              name: 'distributionCondition',
              component: distributionCondition,
            },

          ]
        },
        //会员详情
        {
          path: 'userInfo',
          name: 'userInfo',
          component: userInfo,
          children: [{
            path: 'BasicInfo',
            name: 'BasicInfo',
            component: BasicInfo
          }, {
            path: 'RelationInfo',
            name: 'RelationInfo',
            component: RelationInfo
          }, {
            path: 'HealthInfo',
            name: 'HealthInfo',
            component: HealthInfo
          }, {
            path: 'DeviceInfo',
            name: 'DeviceInfo',
            component: DeviceInfo
          }, {
            path: 'SMDInfo',
            name: 'SMDInfo',
            component: SMDInfo
          }, {
            path: 'SleepData',
            name: 'SleepData',
            component: SleepData
          }, {
            path: 'HemopiezometerInfo',
            name: 'HemopiezometerInfo',
            component: HemopiezometerInfo
          }]
        },
        //老人信息
        {
          path: 'userDetail',
          component: userDetail,
          children: [{
              path: 'baseInfo',
              component: baseInfo
            },
            {
              path: 'dataMonitoring',
              component: dataMonitoring
            },
            {
              path: 'checkInfo',
              component: checkInfo
            },
            {
              path: 'relative',
              component: relative
            },
            {
              path: 'sleepData',
              name: 'sleepData',
              component: sleepData
            },
          ]
        },
        //修改老人信息
        {
          path: 'editUserDetail',
          component: editUserDetail,
          children: [{
              path: 'editBaseInfo',
              component: editBaseInfo
            },
            {
              path: 'editCheckInfo',
              component: editCheckInfo
            },
            {
              path: 'editRelative',
              component: editRelative
            }
          ]
        },
        //404
        {
          path: '404',
          name: '404',
          component: NotFound
        },
        {
          path: '*',
          redirect: "404",
          component: NotFound
        },
      ]
    },
    {
      path: '/BigData',
      name: 'BigData',
      component: BigData
    },
    {
      path: '/BigDataU1',
      name: 'BigDataU1',
      component: BigDataU1
    },
    {
      path: '/BigDataUE_C',
      name: 'BigDataUE_C',
      component: BigDataUE_C
    },
    
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js